<template>
  <div class="page-wrap">
    <div v-if="title">
      <div slot="header" class="clearfix" style="border-bottom:0px; padding-top:20px;">
        <h3 class="page-title">{{title}}</h3>
        <div class="page-line"></div>
      </div>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: "PageWrapper",
  props: {
    title: String
  }
};
</script>
<style lang="scss" scoped>
.page-wrap {
  padding: 0px 10px 20px;
  [data-theme="theme1"] & {
    .page-title {
      font-size: 16px;
      color: #00ece5;
      line-height: 32px;
    }
    .page-line {
      height: 1px;
      width: 99%;
      border-bottom: 1px dashed #00ece5;
    }
  }
  [data-theme="theme2"] & {
    .page-title {
      font-size: 16px;
      color: #001F38;
      line-height: 32px;
    }
    .page-line {
      height: 1px;
      width: 99%;
      border-bottom: 1px dashed #001F38;
    }
  }
    [data-theme="theme2_skyblue"] & {
    .page-title {
      font-size: 16px;
      color: #0060AA;
      line-height: 32px;
    }
    .page-line {
      height: 1px;
      width: 99%;
      border-bottom: 1px dashed #0060AA;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PageWrapper/index.vue